import { render } from "./table-commercial.svg?vue&type=template&id=d0260a48?inline"
const script = {}
script.render = render

export default script